export default __webpack_public_path__ + "static/insightBlog-4bb9a43b844d2908a51d73ef119f8492.svg";